import { cn } from '@/utils';

type Props = React.HTMLAttributes<HTMLDivElement>;

const LinearProgress = ({ className, ...props }: Props) => {
  return (
    <div
      className={cn(
        'relative h-1 w-full overflow-hidden bg-gray-disabled',
        className
      )}
      {...props}
    >
      <span className="absolute left-0 top-0 bottom-0 bg-gradient-horizontal animate-linear-progress" />
      <span className="absolute left-0 top-0 bottom-0 bg-gradient-horizontal animate-linear-progress-2" />
    </div>
  );
};

export { LinearProgress };
